import styles from "../../../static/css/pages.module.css";
import Icon from "../../../components/icons/icons";
import React from "react";
import {connect} from "react-redux";
import * as consts from "../../../store/constants/sidebar";
import { sidebarActions } from "../../../store/actions/sidebarActions";
import navigation from './navigation';
import CounterNotifications from "./counters/notifications";
import CounterTaxes from "./counters/taxes";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      taxesAmount: '',
      counters: {
        notifications: ''
      }
    }
  }

  componentDidMount() {
    this.props.fetchData(navigation, this, consts.SIDEBAR);

    let url = window.location.href;
    let params = url.split('page/')[1];
    const currentData = [];
    function getNavigation(item) {
      if(item.value === params) {
        currentData.push({
          label: item.label,
          value: item.value,
          icon: item.icon,
          subitem: item.subitem,
          current: true
        })
      } else {
        currentData.push({
          label: item.label,
          value: item.value,
          icon: item.icon,
          subitem: item.subitem,
          current: false
        })
      }
    }
    navigation.map(getNavigation);
    this.props.fetchData(currentData, this, consts.SIDEBAR);

  }

  handleClick = (e) => {
    const currentData = [];
    function updateNavigation(item) {
      if(item.value === e) {
        currentData.push({
          label: item.label,
          value: item.value,
          icon: item.icon,
          subitem: item.subitem,
          current: true
        })
      }
      else {
        currentData.push({
          label: item.label,
          value: item.value,
          icon: item.icon,
          subitem: item.subitem,
          current: false
        })
      }
    }
    navigation.map(updateNavigation);
    window.history.pushState("object or string", "Title", process.env.PUBLIC_URL + '/page/' + e);
    this.props.fetchData(currentData, this, consts.SIDEBAR);
  }

  render() {
    const partner = this.props.partnerProperties.items;
    if(this.props.data.items && partner) {
        return <React.Fragment>
          {this.props.data.items.map((item, i) =>
            <React.Fragment key={i}>
              {(item.value === 'clients' || item.value === 'registerClient') && !partner.data?.autoRegistrationIncomes  ?
                null :
                    <div className={`${styles.content} ${styles.content_title}`}
                         data-class={item.subitem}
                         data-menu={item.value}
                         onClick={() => this.handleClick(item.value)}
                         key={i} data-current={item.current}>
                      <Icon name={item.icon} viewbox="0 0 64 64" />
                      <span className={styles.text_gray}>{item.label}</span>
                    </div>
              }
            </React.Fragment>
          )}
          <CounterNotifications />
          <CounterTaxes />
        </React.Fragment>
      }
      else {
        return null;
      }
  }
}

const mapStateToProps = state => ({data: state.sidebarNav, taxes: state.paymentDocument, partnerProperties: state.partnerProperties});

const mapDispatchToProps = dispatch => {
  return {fetchData: (data, parent, types) => dispatch(sidebarActions(data, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);